const ITEMS = [
  "Precision",
  "Meets",
  "Beauty",
  "First Access",
  "Lace & Bond",
  "04 · 19 · 2027",
];

const Row = ({ ariaHidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {ITEMS.map((item, i) => (
      <div key={`${item}-${i}`} className="flex items-center">
        <span
          className={`whitespace-nowrap px-8 md:px-12 text-[0.68rem] md:text-[0.78rem] tracking-[0.42em] uppercase ${
            item === "Lace & Bond"
              ? "font-serif-lux italic normal-case tracking-[0.12em] text-[1.1rem] md:text-[1.35rem] text-[color:var(--champagne)]"
              : "text-[color:var(--muted)]"
          }`}
        >
          {item}
        </span>
        <span className="h-[5px] w-[5px] rotate-45 border border-[color:var(--bronze)] opacity-60" />
      </div>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="overflow-hidden border-y border-[color:var(--champagne)]/15 py-5 md:py-6"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);

export default Marquee;
